export class LaunchConfigError extends Error {
  constructor(
    public readonly reason: string,
    message: string,
    options?: ErrorOptions,
  ) {
    super(message, options);
    this.name = 'LaunchConfigError';
  }
}
